import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import globalRequest from "../../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit } from "../../../../../../utils/helper/constants";
import { changeLoader } from "../../../../../../redux/reducers/loader";
import { useNavigate } from "react-router-dom";
import { roundToDecimal } from "../../../../../../utils/helper/utils";

const SalesByDeliveryMode = ({ inputData, tabIndex }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const [paginationModel] = useState(paginationLimit);
  const [dataSource, setDataSource] = useState([]);

  const getAllReportsByDeliveryMode = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(Apis.MANAGE_REPORT.GET_ALL_PAYMENTS_REPORT_BY_DELIVERY_MODE, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (apiResponse?.status === "SUCCESS") {
        if (apiResponse?.data?.items) {
          let resultData = [];
          for (let key in apiResponse?.data?.items) {
            let item = apiResponse?.data?.items[key];
            resultData.push({
              key: key,
              deliveryMode: item.deliveryMode,
              totalAmount: roundToDecimal(item.totalAmount, 2),
              totalCount: item.totalCount,
            });
          }
          setDataSource(resultData);
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReportsByDeliveryMode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const columns = [
    {
    title: "ID",
    dataIndex: "id",
    key: "id",
    sorter: (a, b) => a.id - b.id,
    render: (text) => text || "-"
  },
    {
      title: "Delivery Mode",
      dataIndex: "deliveryMode",
      key: "deliveryMode",
      render: (text) => text ? text.toUpperCase() : "", 
    },
    {
      title: "Total amount",
      dataIndex: "totalAmount",
      key: "totalAmount",
    },
    {
      title: "Total Orders",
      dataIndex: "totalCount",
      key: "totalCount",
      render: (text, record) => (
        <Typography
          onClick={() => {
            navigate(`/get-delivery-mode/${record?.deliveryMode}`, {
              state: { inputData: inputData, tabIndex: tabIndex },
            });
          }}
          className="cursor-pointer text-[#176B53]"
        >
          {text}
        </Typography>
      ),
    },
  ];

  return (
   <>
      <Table columns={columns} dataSource={dataSource} className="multi-tables responsive" />
   </>
  )
};

export default SalesByDeliveryMode;
